import images from "@/assets/images";
import Button from "@/components/Button";
import Constants from "@/constants";
import { useAnimationTime } from "@/hooks";
import { clickGeneralDownload } from "@/report";
import { downloadFile } from "@/utils";
import classnames from "classnames";
import React from "react";

interface IMoreProductsComponentProps {
  isBigScreen?: boolean;
}
const MoreProductsComponent: React.FC<IMoreProductsComponentProps> = () => {
  const { isAnimationFirst } = useAnimationTime();
  const [isBigScreen, setIsBigScreen] = React.useState(true);
  // 这个页面布局比较特殊。大于1920才使用大屏UI
  React.useEffect(() => {
    const handleResize = () => {
      setIsBigScreen(window.innerWidth >= 1920);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div
      className={classnames(
        isBigScreen ? "mx-[14.2vw]" : "mx-[45px]",
        "more-products-animation flex min-h-full flex-col items-center justify-center",
        !isAnimationFirst && "!ani-delay-0",
      )}
    >
      <div>
        <div
          className={classnames(
            "mb-[20px] flex rounded-[12px] bg-[#FFFFFF0F]",
            isBigScreen ? "max-p-[26px]" : "max-p-[20px]",
          )}
        >
          <img
            src={images.PC41}
            className={classnames(
              "max-mr-[32px]",
              isBigScreen ? "u-max-w-[309px] u-max-h-[200px]" : "u-max-w-[205px] u-max-h-[140px]",
            )}
          />
          <div className="flex flex-1 flex-col justify-between">
            <div>
              <p
                className={classnames(
                  "text-[#0EF69C]",
                  isBigScreen
                    ? "max-text-[32px] max-leading-[42px]"
                    : "text-[24px] max-leading-[34px]",
                )}
              >
                虎牙直播 x 三角州地图工具
              </p>
              <p
                className={classnames(
                  "text-[#FFFFFFBF]",
                  isBigScreen ? "mt-[8px] max-text-[16px]" : "mt-[5.6px] text-[12px]",
                )}
              >
                0成本熟图、摸金模拟、路线规划
              </p>
            </div>
            <Button
              className={classnames(
                "bg-green",
                isBigScreen ? "u-max-w-[211px] u-max-h-[52px]" : "u-max-w-[141px] u-max-h-[36px]",
              )}
              onClick={() => {
                downloadFile(Constants.DOWNLOAD_URL.DELTA_MAP_TOOL);
                clickGeneralDownload({
                  button_name: "下载PC电脑版",
                  product_name: "3",
                });
              }}
            >
              <div className="flex items-center">
                <img
                  src={images.iconWindow1}
                  className={classnames(
                    isBigScreen
                      ? "u-max-w-[28px] u-max-h-[28px] max-mr-[8px]"
                      : "u-max-w-[20px] u-max-h-[20px] max-mr-[4px]",
                  )}
                />
                <p
                  className={classnames(
                    "font-[500] text-[#0B0B0B]",
                    isBigScreen ? "max-text-[18px]" : "text-[12px]",
                  )}
                >
                  下载PC电脑版
                </p>
              </div>
            </Button>
          </div>
        </div>
        <div className="flex">
          <div
            className={classnames(
              "flex flex-col justify-between rounded-[12px] bg-[#FFFFFF0F]",
              isBigScreen ? "max-p-[26px]" : "max-p-[20px]",
            )}
          >
            <div>
              <p
                className={classnames(
                  "text-[#fff]",
                  isBigScreen
                    ? "max-text-[32px] max-leading-[42px]"
                    : "text-[24px] max-leading-[34px]",
                )}
              >
                PC极速版客户端
              </p>
              <p
                className={classnames(
                  "whitespace-break-spaces text-[#FFFFFFBF] max-leading-[22px]",
                  isBigScreen ? "mt-[8px] max-text-[16px]" : "mt-[5.6px] text-[12px]",
                )}
              >
                {"基于全新微软.NET Core内核\n更快，更稳定，更兼容"}
              </p>
            </div>

            <Button
              className={classnames(
                "bg-primary",
                isBigScreen
                  ? "mt-[24px] u-max-w-[200px] u-max-h-[52px]"
                  : "mt-[16px] u-max-w-[105px] u-max-h-[36px]",
              )}
              onClick={() => {
                downloadFile(Constants.DOWNLOAD_URL.PC_EXPRESS);
                clickGeneralDownload({
                  button_name: "立即下载",
                  product_name: "4",
                });
              }}
            >
              <div className="flex items-center">
                <img
                  src={images.iconWindow1}
                  className={classnames(
                    isBigScreen
                      ? "u-max-w-[28px] u-max-h-[28px] max-mr-[8px]"
                      : "u-max-w-[20px] u-max-h-[20px] max-mr-[4px]",
                  )}
                />
                <p
                  className={classnames(
                    "font-[500] text-[#0B0B0B]",
                    isBigScreen ? "max-text-[18px]" : "text-[12px]",
                  )}
                >
                  立即下载
                </p>
              </div>
            </Button>
          </div>
          <div
            className={classnames(
              "ml-[20px] flex flex-1 justify-between rounded-[12px] bg-[#FFFFFF0F]",
              isBigScreen ? "max-p-[26px]" : "max-p-[20px]",
            )}
          >
            <div className="flex flex-col justify-between">
              <div>
                <p
                  className={classnames(
                    "text-[#fff]",
                    isBigScreen
                      ? "max-text-[32px] max-leading-[42px]"
                      : "text-[24px] max-leading-[34px]",
                  )}
                >
                  奶瓶加速器
                </p>
                <p
                  className={classnames(
                    "whitespace-break-spaces text-[#FFFFFFBF] max-leading-[22px]",
                    isBigScreen ? "mt-[8px] max-text-[16px]" : "mt-[5.6px] max-text-[12px]",
                  )}
                >
                  {"专业电竞级 Steam 游戏加速器，高速专网\n关键时刻奶你一口"}
                </p>
              </div>

              <Button
                className={classnames(
                  "bg-primary",
                  isBigScreen
                    ? "mt-[24px] u-max-w-[200px] u-max-h-[52px]"
                    : "mt-[16px] u-max-w-[105px] u-max-h-[36px]",
                )}
                onClick={() => {
                  downloadFile(Constants.DOWNLOAD_URL.NAIPING_ACCELERATOR);
                  clickGeneralDownload({
                    button_name: "立即下载",
                    product_name: "5",
                  });
                }}
              >
                <div className="flex items-center">
                  <img
                    src={images.iconWindow1}
                    className={classnames(
                      isBigScreen
                        ? "u-max-w-[28px] u-max-h-[28px] max-mr-[8px]"
                        : "u-max-w-[20px] u-max-h-[20px] max-mr-[4px]",
                    )}
                  />
                  <p
                    className={classnames(
                      "font-[500] text-[#0B0B0B]",
                      isBigScreen ? "max-text-[18px]" : "text-[12px]",
                    )}
                  >
                    立即下载
                  </p>
                </div>
              </Button>
            </div>
            <img
              src={images.PC42}
              className={classnames(
                isBigScreen
                  ? "ml-[32px] shrink-0 u-max-w-[302px] u-max-h-[200px]"
                  : "ml-[16px] u-max-w-[205px]",
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreProductsComponent;
